import React from 'react';

const Clients = () => {
    const clients = [
        "client1.png", "client2.png", "client3.png", "client4.png", "client5.png"
    ];

    return (
        <section id="clients" className="py-16 bg-white">
            <div className="container mx-auto px-6">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Clients</h2>
                    <div className="w-20 h-1 bg-red-600 mx-auto"></div>
                </div>

                <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
                    {clients.map((client, index) => (
                        <div
                            key={index}
                            className="w-32 h-32 flex items-center justify-center grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition duration-300"
                        >
                            <img
                                src={`/assets/images/${client}`}
                                alt={`Client ${index + 1}`}
                                className="max-h-20 max-w-full"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Clients;